<template>
  <svg fill="none" height="18" viewBox="0 0 18 18" width="18">
    <path
      d="M2.72763 7.5625C2.26188 7.99698 2 8.48672 2 9.00481C2 10.7971 5.13401 12.25 9 12.25C12.866 12.25 16 10.7971 16 9.00481C16 8.48672 15.7381 7.99698 15.2724 7.5625M2.72763 11.3125C2.26188 11.747 2 12.2367 2 12.7548C2 14.5471 5.13401 16 9 16C12.866 16 16 14.5471 16 12.7548C16 12.2367 15.7381 11.747 15.2724 11.3125"
      stroke="currentColor"
      stroke-width="2"
    />
    <path
      d="M16 5.21875C16 5.82876 15.5132 6.61976 14.1904 7.31731C12.9133 7.99077 11.0799 8.4375 9 8.4375C6.92008 8.4375 5.08668 7.99077 3.8096 7.31731C2.48683 6.61976 2 5.82876 2 5.21875C2 4.60874 2.48683 3.81774 3.8096 3.12019C5.08668 2.44673 6.92008 2 9 2C11.0799 2 12.9133 2.44673 14.1904 3.12019C15.5132 3.81774 16 4.60874 16 5.21875Z"
      stroke="currentColor"
      stroke-width="2"
    />
  </svg>
</template>

<script>
  export default {
    name: 'DatabaseIcon',
  };
</script>
